import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { useMutation } from '@tanstack/react-query'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
import useDialog from 'hooks/Shared/useDialog'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { MutationOptions } from 'models/general'
import { IInvoice } from 'models/invoices.models'
import { sendPaymentComplementByEmail } from 'services/Invoices/invoices.services'

const useSendPaymentComplementByEmail = (
  workspaceId: number,
  options: MutationOptions<void, { payComplement: any; invoice: IInvoice }> = {}
) => {
  const dialog = useDialog()
  const { onBefore, onError, noDialog, ...rest } = options

  const mutation = useMutation<
    void,
    any,
    { payComplement: any; invoice: IInvoice }
  >(
    ({ payComplement, invoice }) => {
      if (!invoice.idCfdi) throw new Error('CFDI cargado incorrectamente')
      onBefore && onBefore({ payComplement, invoice })
      return sendPaymentComplementByEmail(
        workspaceId,
        invoice.idCfdi,
        payComplement.idPayment
      )
    },
    {
      ...rest,
      onError: async (error, variables, ctx) => {
        if (error.message === 'mutation-cancelled') return
        const op = selectErrorDialog(error)
        if (op?.variant) {
          await dialog[op.variant](op)
          return
        }
        if (!noDialog) {
          const rp = await dialog.dangerAsync({
            title: 'generic.error.title',
            subtitle:
              'No se pudo eliminar la categoría seleccionada. Intenta nuevamente.',
            icon: ErrorOutline as TModalIcon,
            primaryButtonText: 'Reintentar',
            secondaryButtonText: 'Cancelar',
          })

          if (rp) {
            mutation.mutate(variables)
            return
          }
        }

        onError && onError(error, variables, ctx)
      },
    }
  )

  return mutation
}

export default useSendPaymentComplementByEmail
